import { Link } from 'react-router-dom';
import { DASHBOARDS, canOpen } from '../dashboards';
import { Logo, UserChip } from './PageHeader';

export default function Menu({ session, apps, onSignOut }) {
  const available = DASHBOARDS.filter(d => canOpen(apps, d));

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: '24px 24px 60px' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 40 }}>
        <Logo />
        <UserChip session={session} onSignOut={onSignOut} />
      </header>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Dashboards</h2>

      {available.length === 0 ? (
        <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: 32, textAlign: 'center', color: 'var(--text2)', fontSize: 14 }}>
          No dashboards are assigned to your account yet. Contact Diego to request access.
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: 16 }}>
          {available.map(d => (
            <Link
              key={d.id}
              to={d.path}
              style={{ display: 'block', background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 14, padding: 22, boxShadow: 'var(--shadow)' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--green)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; }}
            >
              <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 6 }}>{d.title}</div>
              <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.5, marginBottom: 14 }}>{d.description}</div>
              <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--green)' }}>Open →</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
